import { render, staticRenderFns } from "./waterQualityCenter.vue?vue&type=template&id=543aecac&scoped=true"
import script from "./waterQualityCenter.vue?vue&type=script&lang=js"
export * from "./waterQualityCenter.vue?vue&type=script&lang=js"
import style0 from "./waterQualityCenter.vue?vue&type=style&index=0&id=543aecac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543aecac",
  null
  
)

export default component.exports